export default __webpack_public_path__ + "static/1946-b4e3666608fb259cedb28dab41652d5a.gif";